var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomatedTrafficFineNotificationServicesSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.6416,
    cy: 13.9802,
    rx: 5.77585,
    ry: 4.62474,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3332 14.0003C23.3332 19.155 19.1545 23.3337 13.9998 23.3337C8.84518 23.3337 4.6665 19.155 4.6665 14.0003C4.6665 8.84567 8.84518 4.66699 13.9998 4.66699C19.1545 4.66699 23.3332 8.84567 23.3332 14.0003ZM17.7615 11.172C18.0348 11.4454 18.0348 11.8886 17.7615 12.162L13.0948 16.8286C12.8214 17.102 12.3782 17.102 12.1049 16.8286L10.2382 14.962C9.96483 14.6886 9.96483 14.2454 10.2382 13.972C10.5116 13.6987 10.9548 13.6987 11.2281 13.972L12.5998 15.3437L14.6857 13.2579L16.7715 11.172C17.0449 10.8987 17.4881 10.8987 17.7615 11.172Z",
    fill: "#EE0033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedTrafficFineNotificationServicesSelected);
export default __webpack_public_path__ + "static/media/AutomatedTrafficFineNotificationServicesSelected.3c607fc4e4d624af46fd563670b6508b.svg";
export { ForwardRef as ReactComponent };